import {useAppContext} from "./useAppContext";
import {contentService} from "../api/contentService";
import {ContactGroupEnumType} from "../definitions/enums";
import {useMemo} from "react";
import {ContactGroupModel} from "../models/domain/contactGroupModel";
import {useSuspenseQuery} from "@apollo/client";

export const useInstallationContactGroupQuery = () => {
    const {catalogId} = useAppContext();

    const {error, data} = useSuspenseQuery(contentService.product.contactGroup, {
        errorPolicy: 'all',
        variables: {
            catalogId: catalogId,
            type: ContactGroupEnumType.Installation
        }
    });

    // Create a new instance of the model with the data from the query result (contactGroup)
    const model = useMemo(() => data?.contactGroup ? new ContactGroupModel(data.contactGroup) : undefined, [data]);

    // Return the model and the error (if any)
    return {model, error}
}